import { BankAccountType } from '@zorro/clients';
import { $enum } from 'ts-enum-util';

export const getBankAccountTypeLabel = (
  bankAccountType: BankAccountType
): string => {
  return $enum.mapValue(bankAccountType).with({
    [BankAccountType.CHECKING]: 'Checking',
    [BankAccountType.SAVINGS]: 'Savings',
  });
};
